import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class PrepaidInvoiceService extends BaseService {
  constructor(protected http: HttpClient) {
    super();
  }

  listForAdmin(page: number, withoutInvoice: boolean) {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('without_invoice', withoutInvoice ? '1' : '0');

    return this.http.get<RequestResponse>(this.setUrl('admin/prepaidManualInvoices'), { params });
  }

  upload(payload: any) {
    return this.http.post<RequestResponse>(this.setUrl('admin/prepaidManualInvoiceUpload'), payload);
  }

  delete(prepaidId: number) {
    return this.http.post<RequestResponse>(this.setUrl('admin/prepaidManualInvoiceDelete'), { prepaid_id: prepaidId });
  }

  listMine() {
    return this.http.get<RequestResponse>(this.getUrl('prepaidManualInvoices'));
  }
}
